import { createStore } from '@crm-framework/saga-injector';

import { toolsReducers } from '@crm-package/tools';

export const store = createStore(toolsReducers, {
  persistedState: {
    dictionaries: {
      currencies: [{ id: 'USD', name: 'USD' }],
    },
  },
});
